import { AWARDS } from '../utils/constants';

// backwards compatibility for old contentful entries
export const getArticleType = (articleType) =>
  articleType === AWARDS.IFDTA ? AWARDS.IFDSA : articleType;
